module.exports = __webpack_public_path__ + "static/media/logo.343a9cd2.png";